module.exports = __webpack_public_path__ + "static/img/clock.d02ed63.png";